/** Copyright 2025 SAP SE or an SAP affiliate company. All rights reserved. */

import store from '@/store/store';
import { useDispatch } from 'react-redux';

export const useAppDispatch: () => typeof store.dispatch = useDispatch;
